import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';
import { isValidLanguage } from '../utils/languageUtils';

/**
 * Language Page Component
 * Handles language switching via query parameters
 * Route: /language?lang=XX
 */
const Language = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { changeLanguage } = useLanguage();
  const { t } = useTranslation();
  const hasChanged = useRef(false);

  useEffect(() => {
    // Prevent multiple executions
    if (hasChanged.current) return;

    const lang = searchParams.get('lang');

    if (lang && isValidLanguage(lang)) {
      hasChanged.current = true;
      // Change the language
      changeLanguage(lang);

      // Redirect to home page after a brief delay
      setTimeout(() => {
        // You can redirect to the previous page if you store it in state
        // For now, redirect to home
        navigate('/', { replace: true });
      }, 500);
    } else {
      // Invalid or missing language parameter, redirect to home
      console.error('Invalid or missing language parameter');
      navigate('/', { replace: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>{t('language.changingLanguage')}</h2>
        <p>{t('language.pleaseWait')}</p>
      </div>
    </div>
  );
};

export default Language;
